import styled, { css } from 'styled-components';
import Link from '@mui/material/Link';
import { withTheme } from '@mui/styles';
import { Colors } from '../../../theme';
import { fontSemibold20 } from './fonts';
export const ellipsis = css `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const StyledLink = withTheme(styled(Link) `
  &.MuiLink-root {
    font-weight: 600;
    color: ${(props) => (props.$isActive ? Colors.blue60 : Colors.black80)};
    text-decoration: none;

    &:hover {
      color: ${(props) => (props.$isActive ? Colors.blue60 : Colors.black80)};
      text-decoration: none;
      cursor: pointer;
      background-color: ${Colors.black10};
    }

    &:focus,
    &:active {
      color: ${Colors.blue60};
      text-decoration: none;
    }
  }
`);
export const GroupName = styled.header `
  margin-bottom: 8px;
  padding: 0 16px;
  display: none;
  ${fontSemibold20}
  color: ${Colors.black80};

  &:first-child {
    display: block;
  }
`;
//# sourceMappingURL=ui.js.map